<template>
  <div class="testimonial_area testimonial_bg_1 overlay">
    <a-carousel arrows :autoplay="true" :dots="false">
      <template #prevArrow>
        <div class="custom-slick-arrow" style="left: 10px; z-index: 1">
          <left-circle-outlined />
        </div>
      </template>
      <template #nextArrow>
        <div class="custom-slick-arrow" style="right: 10px">
          <right-circle-outlined />
        </div>
      </template>
      <div class="single_testmoial">
        <div class="container">
          <div class="row">
            <div class="col-xl-12">
              <div class="testmonial_text text-center">
                <div>
                  <img
                    class="author_img"
                    src="@/assets/images/testmonial/cbs.png"
                    alt=""
                  />
                </div>
                <p>
                  我们将把人工智能知识普及作为前提和基础。及时将 人工
                  智能的新技术、新知识<br />
                  、新变化提炼概括为新的话语体系，根 据大中小学生的
                  不同认知特点，让人工智<br />
                  能新技术、新知识进学 科、进专业、进课程、进教材、 进课堂。
                </p>
                <span>陈宝生部⻓在2019国际人工智能与教育大会上的主旨报告</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="single_testmoial">
        <div class="container">
          <div class="row">
            <div class="col-xl-12">
              <div class="testmonial_text text-center">
                <div>
                  <img
                    class="author_img"
                    src="@/assets/images/testmonial/kk.png"
                    alt=""
                  />
                </div>
                <p>
                  我认为每个人在高中毕业前都应该学习编程，实际上我认为应该在小学就开始教
                  <br />
                  ，"他认为编码是"唯一的通用语言"。"这是你能学到的最重要的语言，当然，你的
                  <br />
                  母语对沟通更重要，但编程语言是一种挖掘你的创造力的方式。
                </p>
                <span>苹果CEO蒂姆库克接受媒体采访</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </a-carousel>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { LeftCircleOutlined, RightCircleOutlined } from "@ant-design/icons-vue";

export default defineComponent({
  components: {
    LeftCircleOutlined,
    RightCircleOutlined,
  },
  mounted() {},
  setup() {},
});
</script>

<style scoped>
/* For demo */
.ant-carousel :deep(.slick-slide) {
  text-align: center;
  overflow: hidden;
}

.ant-carousel :deep(.slick-arrow.custom-slick-arrow) {
  width: 30px;
  height: 30px;
  font-size: 30px;
  color: #fff;
  background-color: rgba(31, 45, 61, 0.11);
  opacity: 0.3;
  z-index: 1;
}
.ant-carousel :deep(.custom-slick-arrow:before) {
  display: none;
}
.ant-carousel :deep(.custom-slick-arrow:hover) {
  opacity: 0.5;
}

.ant-carousel .slick-slide img {
  display: inline;
}

.ant-carousel :deep(.slick-slide h3) {
  color: #fff;
}
</style>
